import React from 'react'

import SimpleBillingContainer from './SimpleBillingContainer'

export default function SimpleBillingScreen() {
    return <SimpleBillingContainer />
}
